import { ON_BETA_DASHBOARD_SELECTED_EVENT_FILTER_CHANGE } from '../actions.js';

const initialState = 'all';

export default (state = initialState, action) => {
  if (action.type === ON_BETA_DASHBOARD_SELECTED_EVENT_FILTER_CHANGE) {
    return action.payload;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers/selected-event-filter.js